import React from "react";
import {useState, useEffect} from "react"
import Header from "../components/Header";
import Footer from "../components/Footer";
import img1 from "../media/menswear_1.avif"
import img2 from "../media/menswear_2.avif"
import slide1 from "../media/men_slide_1.avif"
import slide2 from "../media/men_slide_2.avif"
import slide3 from "../media/men_slide_3.avif"
import { motion, AnimatePresence } from "framer-motion"

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

export default function Menswear() {

  const slides = [
    slide1,
    slide2,
    slide3
  ]

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000); // change every 4 seconds
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <>
      <Header />
      <main>
        <motion.section
            className="bg-brand pt-36 md:pt-44 text-white py-20 text-center"
            initial="hidden"
            whileInView="visible"
            variants={fadeInUp}
            viewport={{ once: true }}
          >
            <h1 className="text-4xl md:text-5xl font-bold">Menswear</h1>
          </motion.section>
          <motion.section
            className="bg-orange-50 py-16"
            initial="hidden"
            whileInView="visible"
            variants={fadeInUp}
            viewport={{ once: true }}
          >
            <div className="max-w-6xl mx-auto  grid md:grid-cols-2 gap-12 items-center px-6">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#BF5717] mb-4">
                  Menswear
                </h2>
                <h2 className="text-xl font-serif font-bold text-black">
                  Modern Style, Superior Craftsmanship
                </h2>
                <p className="mb-6 text-gray-700">
                  Our menswear collection is designed to meet the needs of global brands, combining timeless tailoring with innovative fabrics and finishes. From formal to casual, we ensure every garment reflects quality and trend-awareness.
                </p>
              </div>
              <div>
                <img
                  src={img1}
                  alt="Why Brands Need Us"
                  className="rounded-lg shadow-lg"
                />
              </div>
            </div>
          </motion.section>
        {/* Range Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-2 gap-8 items-center p-16 mb-16"
        >
          <div>
            <div className="pl-0 md:pl-20">
            <p className="text-2xl md:text-4xl text-brand font-semibold mb-4">
              Our Range Includes:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-black">
              <li className="font-serif text-base md:text-xl" key="1" >Jackets & Coats</li>
              <li className="font-serif text-base md:text-xl" key="2" >Shirts & Polo Shirts</li>
              <li className="font-serif text-base md:text-xl" key="3" >Jeans, Chinos & Trousers</li>
              <li className="font-serif text-base md:text-xl" key="4" >Knitwear & Sweaters</li>
              <li className="font-serif text-base md:text-xl" key="5" >Casualwear & Loungewear</li>
            </ul>
          </div>
          </div>

          <motion.img
            src={img2}
            alt="Menswear Range"
            className="shadow-lg "
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          />
        </motion.div>
        <motion.div
          className="max-w-6xl mx-auto mb-16 text-center"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true }}
        >
          <h1 className="font-serif text-center text-xl md:text-2xl lg:text-3xl text-slate-600">
            Each piece is crafted with attention to fit, durability, and style — offering men versatile choices for work, leisure, and everything in between.
          </h1>
        </motion.div>
        <div className="relative w-full h-[500px] overflow-hidden rounded-lg shadow-lg">
          <AnimatePresence mode="wait">
            <motion.img
              key={current}
              src={slides[current]}
              alt={`Slide ${current + 1}`}
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.8 }}
              className="absolute w-full h-full object-cover"
            />
          </AnimatePresence>

          {/* Dots Navigation */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
            {slides.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`w-3 h-3 rounded-full ${
                  i === current ? "bg-brand" : "bg-gray-200"
                }`}
              ></button>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
